function LayersEmpty() {
  return <div className="text-center text-sm">No Layers</div>;
}

export default LayersEmpty;
